import $api from "../http";
import { IClassCategory } from "../models/ClassCategory";

class ClassCategoryServiceClass {
  async getAllClassesCategories(searchValue: string | null) {
    const query = searchValue ? `?searchValue=${searchValue}` : "";
    return await $api.get<IClassCategory[]>(`api/class-category${query}`);
  }

  async update(id: string, model: Omit<IClassCategory, "id">) {
    return await $api.put<{}>(`api/class-category/${id}`, model);
  }

  async create(model: Omit<IClassCategory, "id">) {
    return await $api.post<{}>(`api/class-category`, model);
  }
}

export const ClassCategoryService = new ClassCategoryServiceClass();
